import { DateTime } from "luxon";

export const checkPlaylistIsActive = (
    playlistInfo,
    setPlaylistActive,
    setPlaylistStreamURL
) => {
    if (!playlistInfo || playlistInfo.length === 0) return;

    const serverTimezone = "Europe/Dublin";
    const now = DateTime.now().setZone(serverTimezone);
    const format = "yyyy-MM-dd HH:mm:ss";

    let activeFound = false;

    const startEvents = playlistInfo.filter((e) => e.event_type === "start");

    startEvents.forEach((startEvent) => {
        const stopEvent = playlistInfo.find(
            (e) =>
                e.event_type === "stop" &&
                e.post_id === startEvent.post_id &&
                e.playlist_id === startEvent.playlist_id
        );

        if (stopEvent) {
            const startTime = DateTime.fromFormat(
                startEvent.event_time,
                format,
                { zone: serverTimezone }
            );
            const stopTime = DateTime.fromFormat(stopEvent.event_time, format, {
                zone: serverTimezone,
            });

            console.log(
                `Checking playlist ID: ${
                    startEvent.playlist_id
                }, Start: ${startTime.toISO()}, Stop: ${stopTime.toISO()}`
            );

            if (now >= startTime.minus({ minutes: 2 }) && now <= stopTime) {
                const streamId = startEvent.playlist_stream_id;
                setPlaylistStreamURL(
                    `https://cdn.starsystems.ie/CCLPlaylists/streams/${streamId}.m3u8`
                );
                setPlaylistActive(true);
                console.log("Playlist is active for stream ID:", streamId);
                activeFound = true;
            }
        }
    });

    if (!activeFound) {
        console.log("No active playlist found for the current time.");
        setPlaylistActive(false);
    }
};
